module.exports = __webpack_public_path__ + "6bde5c3d98c121fbb9bc407e14f3e876.svg";